export const home = {
  title: '海洋遥感大数据信息服务与决策中心',
  Welcome: '欢迎您',
  introduce: '南方海洋实验室目标是建设面向科技前沿、具有国际领先水平的海洋创新基础平台，构筑世界一流的海洋人才高地，打造创新型、引领型、突破型的大型综合性海洋研究和应用基地',
  Platform: '平台公告',
  ViewAll: '查看全部',
  ProductCategoricalData: '产品分类数据',
  MarineHydrology: '海洋水文',
  MarineMeteorology: '海洋气象',
  PolarMarine: '极地海洋',
  Topography: '地形地貌',
  MarineBiology: '海洋生物',
  MarineEcology: '海洋生态',
  ObservationData: '观测数据',
  SatelliteCategoricalData: '卫星分类数据',
  NumberofSatellites: '卫星颗数',
  Scenesofdatafile: '数据文件景数',
  DataStorage: '数据存储',
  LatestProductData: '最新产品数据',
  PopularProductData: '热门产品数据',
  PictureoftheDay: '每日一图',
  CartographicInstitution: '制图单位',
  CoordinateSystem: '坐标系',
  ScaleBar: '比例尺',
  ProcessingDate: '制图时间',
  NewsCenter: '新闻中心',
  News: '新闻动态',
  IndustryNews: '行业动态',
  AlgorithmStatistics: '算法统计',
  TotalNumberofAlgorithms: '算法总数量',
  TotalNumberofProducedProducts: '已生产产品总数量',
  TotalProducedDataVolume: '已生产总数据量',
  ResourceStatistics: '资源统计',
  ServiceStatistic: '服务统计',
  TotalNumberofProductData: '产品数据总数',
  TotalVolumeofProductData: '产品数据总量',
  TotalNumberofSatelliteData: '卫星数据总数',
  TotalVolumeofSatelliteData: '卫星数据总量',
  NumberofRegisteredUsers: '注册人数',
  WebsiteVisits: '网站访问量',
  TotalDownloadVolume: '总下载量',
  TotalDownloadCounts: '总下载次数',
  PlatformAnnouncement: '平台公告',
  content: '公告内容',
  time: '发布时间',
  promulgator: '发布者',
  Datatime: '数据时间',
  pcs: '个',
  bar: '条',
  freq: '次',
  scene: '景',
  scenes: '景',
  Stars: '颗',
  Star: '颗',
  set: '套',
  person: '人',
  persons: '人',
  GB: 'GB',
  TB: 'TB',
}
export const footer = {
  OfficialWeChat: '官方微信',
  Address: '地址',
  Address2: '广东省珠海市香洲区唐家湾镇中山大学珠海校区海琴4号楼',
  copyright: '2021南方海洋科学与工程广东省实验室(珠海)版权所有',
  TechnicalSupport: '技术支持',
  SunYatsenUniversity: '中山大学',
  RelatedLinks: '友情链接',
  Address3: '南方海洋科学与工程广东省实验室（珠海）',
  Portal: '三极大数据共享服务平台',
  InternetContentProvider: '粤ICP备19160455号-1',
}
export const header = {
  NightMode: '夜间模式',
  Login: '登录',
  Register: '注册',
  Welcome: '欢迎您',
  PersonalCenter: '个人中心',
  orderForm: '订单',
  Logout: '注销',
  Home: '首页',
  SatelliteData: '卫星数据',
  ProductData: '产品数据',
  AlgorithmPlatform: '平台算法',
  Maps: '一张图展示',
  ServicesResource: '服务资源',
  DataDecisionMaking: '智能决策',
  DataSubmission: '数据汇交',
  About: '关于我们',
  AlgorithmScheduling: '算法监控',
  DataService: '服务管理',
  DataResource: '数据资源',
  OperationManagement: '运维管理',
  RPAManagement: '汇聚监控（RPA）',
  RemoteSensingCloudComputingService: '遥感云计算服务',
  CloudComputingServices: 'GP建模',
  DevelopmentSDK: '开发SDK',
  OrbitPrediction: '轨道预测',
  StormSurgeDisasterPrediction: '风暴潮灾害监测',
  MarineDisasterPreventionandMitigation: '海洋防灾减灾',
  MarineRedTideMonitoring: '海洋赤潮监测',
  PolarSeaIceMonitoring: '极地海冰监测',
  NavigationSecurityinPolarSeaRoute: '极地航道航行安全',
  ProductUpload: '产品汇交',
  ApplicationForSatelliteData: '卫星数据申请',
  AlgorithmManagement: '算法汇交',
  DataDistributionAndTransfer: '人工分发记录',
  AlgorithmsLibrary: '算法库',
  IntroductionOfPlatform: '平台简介',
  LaboratoryIntroduction: '实验室简介',
  ContactUS: '联系我们',
  OrganizationalStructure: '组织框架',
  DevelopmentHistory: '发展历程',
  Applyforremotesensingcloudcomputingservice: '遥感云计算服务申请',
  Applicationduration: '申请时长',
  Descriptionofuse: '用途描述',
  EnvironmentType: '环境类型',
  Serviceconnection: '服务连接',
  UsernameandPassword: '用户名/密码',
  Pleaseenteradescription: '请输入用途描述',
  Unit: '单位',
  Hour: '小时',
  Note: '注释：以上为上一次申请信息',
  Tips: '温馨提示',
  Tips2: '所需遥感影像目录请参考服务资源模块中的数据资源模块',
  ViewOperationVideo: '查看操作视频',
  help: '使用帮助',
}
export const satellite = {
    ClassificationOfTheSatellite: '卫星数据',
    CurrentPosition: '当前位置',
    Home: '首页',
    SatelliteData: '卫星数据',
    placeholder: '请输入内容',
    ProductTypes: '产品类型',
    All: '全部',
    Sensor: '传感器',
    Scenes: '景数',
    DataVolume: '数据量',
    Views: '浏览次数',
    Details: '查看详情',
    Free: '免费',
    ReleaseTime: '发布时间',
    Downloads: '下载次数',
    BasicInformation: '基本信息',
    DatasetName: '数据集名称',
    Resource: '资源提供单位',
    Satellite: '卫星',
    ProductLevel: '产品级别',
    Resolution: '空间分辨率',
    Format: '产品格式',
    TimeSpan: '时间跨度',
    LatestTime: '最新时间',
    Entry: '条目(景)',
    SharedScope: '共享范围',
    CoverageArea: '覆盖区域',
    DataRetrieval: '数据检索',
    CloudCoverSize: '云量大小',
    TimeRange: '时间范围',
    WithinOneWeek: '一周内',
    WithinOneMonth: '一月内',
    WithinOneQuarter: '一季度内',
    WithinHalfayear: '半年内',
    Withinoneyear: '一年内',
    SpaceLocation: '空间位置',
    FullDataCoverage: '全数据覆盖范围',
    SearchbyMap: '地图选择',
    LongitudeandLatitude: '经纬度',
    AreaSearch: '区域检索',
    ImportPolygon: '上传矢量文件',
    TaptoSelect: '点选',
    Rectangle: '矩形',
    Polygon: '多边形',
    reset: '重置',
    Search: '查询',
    longitude: '经度',
    latitude: '纬度',
    latitude1: '请输入西经',
    latitude2: '请输入东经',
    latitude3: '请输入北纬',
    latitude4: '请输入南纬',
    import: '导入',
    tips: '需.zip文件形式，至少包括.dbf、.shp、.prj、.kml 四类文件',
    productInstruction: '产品使用说明',
    p1: '、该卫星数据所有权归原机构所有，已在数据说明中注明',
    p2: '、本平台仅为科研工作用途代为整理，禁止二次转发，禁止用于任何商业用途或其他非科研用途，如有使用需求请联系原机构获取',
    p3: '、如有引用，请注明原机构名称和数据来源，并严格遵守原机构的使用要求',
    Arctic: '北极地区',
    Antarctic: '南极地区',
    SouthChinaSea: '中国南海',
    EastChinaSea: '东海',
    YellowSea: '黄海',
    BohaiSea: '渤海',
    bridge: '粤港澳大湾区',
    Start: '开始时间',
    End: '结束时间',
    dataidentifier: '数据标识',
    Nothumbnail: '无缩略图',
    stripe: '条带号',
    cloudcover: '云量',
    Upperleftlatitudeandlongitude: '左上角经纬度',
    Upperrightlatitudeandlongitude: '右上角经纬度',
    Lowerleftlatitudeandlongitude: '左下角经纬度',
    Latitudeandlongitudeinlowerrightcorner: '右下角经纬度',
  }
export const product = {
  ProductCategory: '产品分类',
  ProductData: '产品数据',
  Subject: '主题词',
  ReleaseTime: '发布时间',
  Salinity: '盐度',
  Datavolume: '数据量',
  Time: '时间',
  Label: '标签',
  LastUpdateTime: '最近更新时间',
  DataAccessVolume: '数据访问量',
  BasicInfo: '基本信息',
  DataContactInfo: '数据联系信息',
  Datatime: '数据时间',
  SpaceLocation: '空间范围',
  SubjectCategory: '主题分类',
  SharingLevel: '共享级别',
  Contact: '联系人',
  Phone: '电话',
  Mail: '邮箱',
  Institution: '单位',
  Address: '地址',
  DataAcquisitionMethod: '数据获取方式',
  AddDataOrder: '加入购物车',
  FillintheDataUsePurpose: '填写数据使用用途',
  DownloadDataOnline: '在线下载数据',
  SubscribetoData: '订阅数据',
  subscribed: '已订阅',
  Favoritedata: '收藏数据',
  Collected: '已收藏',
  ClicktoView: '点击查看',
  DataSummary: '数据摘要',
  DataAttachment: '数据附件',
  DataDescriptionDocument: '数据说明文档',
  DataSamples: '数据样例',
  DataUsageInformation: '数据使用信息',
  AcknowledgementFormat: '致谢格式',
  AcknowledgmentRefertotheFollowingSpecifications: '致谢方式参考以下规范',
  AcknowledgmentinChinese: '中文致谢方式',
  p1: '“感谢南方海洋科学与工程广东省实验室(珠海) 提供数据支撑。”',
  AcknowledgementinEnglish: '英文致谢方式',
  Attention: '注意事项：',
  p2: '1、本数据仅用于实验室相关科研用途,不得用于商用，不得用于公开系统开发与显示。',
  p3: '2、数据申请人员不得私自传播所申请到的数据。',
  p4: '3、利用申请数据发表的论文和其它成果，必须标注数据来源并在致谢中说明。',
  RelevantLiterature: '相关文献',
  p5: '本平台对其发布的或数据贡献者贡献的数据产品或服务及平台上发布的相关信息的全部内容拥有版权等知识产权，受法律保护。',
  p6: '未经本平台书面许可，任何单位及个人不得以任何方式或理由对上述数据产品、服务、信息、材料的任何部分进行复制、修改、抄录、传播及销售。',
  p7: '凡侵犯本平台版权等知识产权的，本平台必依法追究其法律责任，特此郑重声明!',
  DataFile: '数据文件',
  DataFileName: '数据文件名称',
  FileType: '文件类型',
  FileSize: '文件大小',
  Createdtime: '创建时间',
  Operation: '操作',
  Empty: '空',
  AddtoCartinBulk: '批量加入',
  Addalltoshoppingcart: '全部加入',
  shoppingCar: '购物车',
  DownloadedUser: '下载本数据用户',
  UserName: '用户名称',
  Remarks: '备注',
  LatestViewData: '最新浏览数据',
  ProductOverview: '产品概述',
  MetadataInfo: '元数据信息',
  DataType: '数据类型',
  SpatialResolution: '空间分辨率',
  TemporalResolution: '时间分辨率',
  SpatialPosition: '空间范围',
  Datatimerange: '数据时间范围',
  SourceDataofProduct: '产品源数据',
  Websites: '产品相关论文/网站',
  unit: '单位',
  optiondate: '选择日期',
  Introduction: '数据科学背景简介',
  DynamicAnalysis: '数据动态统计分析',
  Maximum: '最大值',
  Average: '平均值',
  Minimum: '最小值',
  StandardDeviation: '标准差',
  Value: '值',
  download: '下载',
  warning: '提示',
  clean: '清除',
  DistanceMeasurement: '测距',
  AreaMeasurement: '测面',
  Queryvalue: '查询',
  Screenshot: '截图',
  Recordscreen: '录屏',
  Clear: '清除',
  Fullscreen: '全屏',
  map2d: '二维地图',
  map3d: '三维地图',
  Searchfortherequireddata: '搜索所需数据',
  Addtodataorder: '加入数据订单',
  Downloaddataonline: '在线下载数据',
  GameEngineEffects: '游戏引擎效果',
}
export const algorithm = {
  algorithmClassification: '算法分类',
  AlgorithmData: '算法数据',
  AlgorithmContributors: '算法贡献者',
  DataContactInformation: '数据联系信息',
  AlgorithmStatus: '算法状态',
  OnlineTime: '上线时间',
  SubjectCategory: '主题分类',
  SharingMetho: '共享方式',
  Region: '空间位置',
  TemporalResolution: '时间分辨率',
  SpatialResolution: '空间分辨率',
  ProgrammingLanguage: '开发语言',
  OperatingPlatform: '运行平台',
  Modelcomplexity: '模型复杂度',
  Modeldrivingdata: '模型驱动数据',
  ModelOutputFormat: '模型输出格式',
  AlgorithmicProductionStatistics: '算法生产统计',
  DataAcquisitionMethod: '数据获取方式',
  DownloadExistingData: '已有数据下载',
  Applicationforoperation: '申请运行',
  AlgorithmSummary: '算法摘要',
  AlgorithmDescription: '算法描述',
  OutputProduct: '输出产品',
  References: '参考文献',
  DataNeedsTime: '数据需要时间',
  SpatialRangeRequiredForData: '数据需要空间范围',
  Gettheoutputpath: '获取输出路径',
}
export const services = {
  Resolution: '分辨率',
  calculating: '计算中',
  Country: '国家',
  SatelliteType: '卫星类型',
  SelectAll: '全选',
  ForecastTime: '预测时间',
  OrbitType: '轨道类型',
  SelectAdministrativeRegion: '行政区选择',
  Pleaseselect: '请选择',
  LoadOrbit: '载入轨道',
  ClearOrbit: '清除轨道',
  ViewResult: '查看结果',
  SwingingAngle: '操作',
  ExportOrbit: '导出轨道',
  play: '播放',
  Total: '过境卫星有效覆盖率总计',
  name: '名称',
  Time: '时间',
  Operation: '操作',
  introduce: '数据介绍',
  copy: '一键复制',
  path: '存放路径',
  China: '中国',
  ESA: '欧空局',
  Japan: '日本',
  America: '美国',
  Descendingorbit: '降轨',
  Ascendingorbit: '升轨',
  All: '全部',
  EntryTime: '入境时间',
  Departuretime: '出境时间',
  Multispectral: '多光谱',
  Microwave: '微波辐射',
  Laseraltimeter: '激光测高仪',
}
export const Intelligent = {
  IntelligentReport: '智能辅助决策报告',
  name: '名称',
  lookOver: '查看',
  NoData: '暂无数据',
}
export const DataSubmission = {
  MyProduct: '我的产品',
  Add: '新增',
  Delete: '删除',
  ProductName: '产品名称',
  Edit: '编辑',
  BasicInformation: '基本信息',
  DataParameterDescription: '数据参数说明',
  DataAttachment: '数据附件',
  BasicProductInformation: '产品基本信息',
  DownloadTemplate: '模板下载',
  ProductCategory: '产品类别',
  SearchbySubject: '检索主题词',
  Timespan: '时间跨度',
  SpatialLocation: '空间位置',
  SubjectCategory: '主题分类',
  SharingLevel: '共享级别',
  TemporalResolution: '时间分辨率',
  TemporalResolutionUnit: '时间分辨率单位',
  ProductBasemap: '产品底图',
  DataType: '数据类型(格式)',
  InputData: '输入数据',
  InputData2: '如有多个请以;分割',
  OtherIntroductionforData: '数据其他介绍',
  ContactAddress: '联系地址',
  Cancel: '取消',
  PreviousStep: '上一步',
  NextStep: '下一步',
  DataDescription: '数据说明',
  DataSummary: '数据摘要',
  ProductThumbnail: '产品缩略图',
  uploadpictures: '图片上传',
  ProductOverviewThumbnail: '产品概述缩略图',
  OtherIntroductionThumbnails: '数据其他介绍缩略图',
  legendType: '图例类型',
  Visualdisplayornot: '是否可视化展示',
  yes: '展示',
  no: '不展示',
  continuity: '连续色带',
  subsection: '分段色带',
  ProductColorbar: '产品色带',
  StartValue: '起始值',
  NumberofLevels: '级数',
  Stopvalue: '终止值',
  Steplength: '步长',
  color: '颜色',
  value: '值',
  name: '名称',
  DataUnit: '数据单位',
  coloreditor: '颜色编辑器',
  preview: '预览',
  confirm: '确定',
  DataDescriptionDocument: '数据说明文档',
  ClicktoUpload: '点击上传',
  SampleData: '数据样例',
  RelevantLiterature: '相关文献',
  Dataupload: '数据上传',
  p1: '上传产品数据时请参考以下目录组织规范',
  p2: '产品数据目录组织规范',
  p3: '数据共享磁盘路径',
  p4: '上传方式说明',
  p5: '共享磁盘路径:可使用工具通过上方数据共字磁盘路径进行上传',
  p6: '直接上传∶影像数据请上传TIF文件，支持文件格式为tif、tift等(后缀不区分大小写)，单个文件最大不超过10GB;矢量数据请上传shpfilc格式文件',
  p7: '拖拽要上传的文件到这里上传',
  p8: '上传到服务器',
  finish: '完成',
  title: '标题',
  Satellite: '卫星名称',
  TimeRangeofData: '数据时间范围',
  SpatialScope: '空间范围',
  State: '状态',
  Operation: '操作',
  Applicationfornewsatellitedata: '新增卫星数据申请',
  Companyname: '单位名称',
  Timerangeofapplicationdata: '申请数据时间范围',
  Resourceprovider: '资源提供单位',
  telephone: '联系电话',
  Datadownloadaddress: '数据下载地址',
  spatialresolution: '空间分辨率',
  Descriptionofuse: '用途描述',
  sensor: '传感器',
  Productlevel: '产品级别',
  Applicationdataspacerange: '申请数据空间范围',
  Submit: '提交',
  Colorlessbelt: '无色带',
  Submitaudit: '提交审核',
  Submittedforreview: '提交待审核',
  Toaudit: '待审核',
}
export const algorithm2 = {
  MyAlgorithm: '我的算法',
  AlgorithmName: '算法名称',
  AlgorithmClassification: '算法分类',
  TemporalResolution: '时间分辨率',
  OutputProductName: '输出产品名称',
  SpatialResolution: '空间分辨率',
  SharingLevel: '共享级别',
  ApprovalStatus: '审核状态',
  Operation: '操作',
  Edit: '编辑',
  Submit: '提交',
  Fail: '未通过',
  NotReviewed: '未审核',
  Approved: '通过',
  ProgrammingLanguage: '开发语言',
  CompileEnvironment: '编译环境',
  ModelOutputProductName: '模型输出产品名称',
  Modelruncycle: '模型运行周期',
  ModelOutputFormat: '模型输出格式',
  AlgorithmCode: '算法代码',
  Related: '相关论文/参考文献',
  ProductSpatialResolution: '产品空间分辨率',
  Productoverviewdescription: '产品概述说明',
  Introductiontoproductsciencebackground: '产品科学背景介绍',
  Scientificbackgroundintroductionthumbnail: '科学背景介绍缩略图',
  DistributionTime: '分发时间',
  name: '姓名',
  Institution: '工作单位',
  Amountofdatadistributed: '分发数据量',
}
export const about = {
  p1: '平台聚焦粤港澳大湾区、南海和极地区域，汇集“天空地人”各类数据、科学算法及大数据挖掘方法，接入国内外各种开放数据，实现数据自动汇集，节约基础数据采集时间。平台将集成实验室的算法资源，实现标准化统一管理，并采用丰富的二三维可视化效果进行展示。平台可面向用户提供在线云计算服务，并能够根据内嵌算法和数据库数据实现专题产品的在线自动化生产。在打造海洋遥感大数据云服务与计算平台的同时，生产具有自主知识产权的创新性专题产品，并提供基于专家和智能决策系统分析的专题报告，实现数据由常规共享向应用决策支持的跨越，服务于粤港澳大湾区、南海与极地区域的环境监测、资源开发、灾害预警和军事安全等诸多国家及区域重大需求。',
  p2: '为深入贯彻落实习近平总书记视察广东重要讲话精神，大力实施创新驱动发展战略，推动高质量发展，广东省委省政府决定建设广东省实验室。南方海洋科学与工程广东省实验室（珠海）（下简称南方海洋实验室）于2018年11月启动建设，并于2018年12月26日举行揭牌仪式暨理事会成立大会。',
  p3: '南方海洋实验室由珠海市人民政府举办，中山大学牵头建设和管理，实行理事会领导下的实验室主任负责制。陈大可院士担任实验室主任，苏纪兰院士担任学术委员会主任。第一届南方海洋实验室学术委员会由来自中国科学院、中国工程院19位院士和12位海洋领域顶尖专家组成。南方海洋实验室目标是建设面向科技前沿、具有国际领先水平的海洋创新基础平台，构筑世界一流的海洋人才高地，打造创新型、引领型、突破型的大型综合性海洋研究和应用基地。',
  p4: '南方海洋实验室采取“一个实体，N个合作单位”的“1＋N”协同创新模式，联合省内外、国（境）内外的优势力量，汇集“粤港澳大湾区”海洋研究的智慧和力量，营造国际合作的良好氛围。截止到2020年，南方海洋实验室已与包括香港、澳门、广东等地高校在内的41家高等院校、研究机构、业务部门及相关企业等签订了合作共建协议。',
  p5: '南方海洋实验室围绕海洋环境与资源、海洋工程与技术、海洋人文与考古三大研究领域，以“崇尚首创，力争最优”为标准，已布局建设十八个创新团队。实验室创新团队通过机制体制创新，形成紧密、稳定、长期的实质性合作，实施多学科交叉融合重大项目，争取在科学前沿、核心关键技术和重大工程实际应用上取得创新性成果，服务国家海洋和区域社会经济发展。',
  p6: '实验室主楼共10万平方米，坐落在钟灵毓秀的海滨城市珠海，依托中山大学珠海校区海洋学科楼群建设，纵览海滨，风光秀丽，预计2021年建成使用。南方海洋实验室将依托6000吨级海洋综合科考实习船、“天河二号”超级计算机、深水半潜平台、海洋智能无人系统组网，大力推进“国际一流，国内领先”的八大公共平台建设。',
  Contactus: '联系我们',
  GeneralManagementDepartment: '综合管理部',
  TechnologyDevelopmentDepartment: '科技发展部',
  HumanResourceDepartment: '人力资源部',
  FinancialAssetsDepartment: '财务资产部',
  CooperationandExchangeDepartment: '合作交流部',
  PlatformFacilitiesDepartment: '平台设施部',
  OrganizationalFramework: '组织框架',
  DevelopmentHistory: '发展历程',
  name: '任洪凯',
}
export const Order = {
  MyOrder: '我的订单',
  Orderquery: '订单查询',
  query: '查询',
  Please: '请输入订单编号查询',
  number: '序号',
  OrderNo: '订单编号',
  subscriptiondate: '订购日期',
  Downloadvalidity: '下载有效期',
  Numberofdata: '数据个数',
  Totaldatavolume: '总数据量',
  Orderstatus: '订单状态',
  operation: '操作',
  download: '下载',
  Orderdetails: '订单详情',
  FTPinformation: 'FTP信息',
  OneclickCopy: '一键复制',
  ShoppingCart: '购物车',
  filename: '文件名',
  Productiontime: '生产时间',
  thumbnail: '缩略图',
  Productname: '产品名',
  datatype: '数据类型',
  fileformat: '文件格式',
  filesize: '文件大小',
  Jointime: '加入时间',
  Selected: '已选择',
  Totaldatasize: '数据大小总计',
  Generateorder: '生成订单',
  Deleteselecteddata: '删除所选数据',
  clearcart: '清空购物车',
  Satellitedatadetails: '卫星数据详情',
  Sensorname: '传感器名称',
  DataNo: '数据编号',
  Datagenerationtime: '数据生成时间',
  Shoppingcartaddtime: '购物车添加时间',
  Shootingtime: '拍摄时间',
  Productdatadetails: '产品数据详情',
  Productdocumentname: '产品文件名称',
  Batchdelete: '批量删除',
  Readytofinish: '准备完成',
  Oneclickordergeneration: '一键生成订单',
  ViewingtheDownloadlist: '查看下载列表',
  Oneclicktoobtainthedownloadaddress: '一键获取下载地址',
  Thedownloadperiodhasexpired: '已过下载期',
  FileDownloadlist: '文件下载列表',
  准备完成: '准备完成',
  提交订单: '提交订单',
  数据准备: '数据准备',
  Ordergenerationinprogress: '订单生成中',
  Pleaseselectatleastonepieceofdata: '请至少选择一条数据',
}
export const newsCenter = {
  NewsCenter: '新闻中心',
  Newsheadline: '新闻标题',
  ReleaseTime: '发布时间',
  Newstype: '新闻类型',
  Publishedby: '发布人',
}
export const personalCenter = {
  myCollection: '我的收藏',
  cancelCollection: '取消收藏',
  Subscribetothetime: '订阅时间',
  mysubscriptions: '我的订阅',
  unsubscribe: '取消订阅',
  mymessage: '我的消息',
  Allhavebeenread: '全部已读',
  MessageContent: '消息内容',
  Messagepushtime: '消息推送时间',
  Messagepublisher: '消息发布者',
  unread: '未读',
  read: '已读',
  addNews: '新增新闻',
  editNews: '编辑新闻',
  Coverthumbnail: '封页缩略图',
  submit: '提交',
  Pleaseinputatitle: '请输入标题',
  p: '请输入新闻概述，且尽量保持在100字以上......',
  NewsTrends: '新闻动态',
  industrytrends: '行业动态',
  laboratoryreport: '实验室报告',
  addannouncement: '新增公告',
  Pleaseenterbulletincontent: '请输入公告内容',
  systematicnotification: '系统通知',
  Settinginvalid: '设置无效',
  SystemNotificationcontent: '系统通知内容',
  status: '通知状态',
  invalid: '无效',
  valid: '有效',
  Addannouncement: '新增通告',
  Pleaseenterthesystemnotificationcontent: '请输入系统通告内容',
  Reviewofsatellitedataapplications: '卫星数据申请审核',
  Audithasbeenpassed: '审核已通过',
  Auditfailed: '审核未通过',
  TO: '至',
  Approved: '已通过审核',
  Downloadurl: '下载网址',
  nopass: '不通过',
  productaudit: '产品审核',
  audit: '审核',
  alreadypassed: '已通过',
  dataformat: '数据格式',
  contactinformation: '联系信息',
  datapresentation: '数据展示',
  algorithmaudit: '算法审核',
  algorithmofinformation: '算法信息',
  productinformation: '产品信息',
  Algorithmthumbnail: '算法缩略图',
  Algorithmcodedownload: '算法代码下载',
  Downloadthecode: '下载代码',
  Cronexpression: 'cron表达式',
  describe: '描述',
  Thedefaultstart: '默认开始',
  Dismissthereason: '驳回原因',
  normal: '正常',
  stop: '停止',
}
export const cloudComputing = {
  text: '遥感云计算平台，是一套基于容器云技术构建的面向地球科学领域的专业的云计算服务平台，基于自动管理的弹性容器环境，多源遥感数据处理、资源调度、实时计算、批量计算和深度学习框架等技术，构建了遥感/测绘专业处理平台、遥感实时分析计算平台、人工智能解译平台，为大众用户进行大规模地理数据分析和科学研究提供了一体化的服务。平台提供python、java、C/C++等不同编译环境，通过打造“开放+共建+共享”的新模式，以高效能、低门槛、低成本的途径挖掘遥感数据价值，使行业快速应用创新，为海洋、极地、自然资源、生态、气象等调查、监测、评价、监管和执法等重点工作提供技术支撑，助力遥感应用产业化发展。',
  ViewingDataResources: '查看数据资源',
  AccountPassword: '账号/密码',
  Applyimmediately: '立即申请',
  Operationguide: '操作引导',
  Blankenvironment: '空白环境',
  Generalalgorithmenvironment: '普通算法环境',
  Deeplearningenvironment: '深度学习环境',
  Mapsource: '底图来源',
  Tianditu: '天地图',
  source: '来源',
  Mapmode: '地图',
  Earthmode: '地球',
  kilometre: '公里',
  statutemile: '英里',
  nauticalmile: '海里',
  Chooseabasemap: '选择底图',
}